var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggleCollapse flex-x-y",on:{"click":_vm.toggle}},[_c('p',{staticClass:"font14 toggleCollapse-text"},[_vm._v(" "+_vm._s(_vm.value ? _vm.collapseText : _vm.expandText)+" ")]),_c('van-icon',{attrs:{"name":_vm.value ? 'arrow-up' : 'arrow-down',"size":"12","color":"#676870"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }